module.exports = new __parcel__URL__("CantEditLight.0ee7f232.svg").toString();